module.exports = __webpack_public_path__ + "img/icon_edit.3337c7d4.svg";